export class Pagination<T> {
    private paginationSize: number;
    private input: Array<T> | null = null;
    private counter: number;

    constructor(paginationSize: number){
        this.paginationSize = paginationSize;
        this.counter = 0;
    }

    public setInputData(input: Array<T>){
        this.input = input;
    }

    public getNext(): Array<T>{
        if(this.input === null){
            return [];
        } else {
            let newCounter = (this.counter + this.paginationSize) > this.input.length ? this.input.length : (this.counter + this.paginationSize);
            this.counter = newCounter;
            console.log("[Pagination][getNextPage] Show " + this.counter + " elements");
            return this.input.slice(0, this.counter);
        }
    }

    public getNextWithInputCounter(inputCounter: number){
        if(this.input === null){
            return [];
        } else {
            let newCounter = (inputCounter + this.paginationSize) > this.input.length ? this.input.length : (inputCounter + this.paginationSize);
            this.counter = newCounter;
            console.log("[Pagination][getNextPage] Show " + this.counter + " elements");
            return this.input.slice(0, this.counter);
        }
    }

    public hasMoreElements(): boolean {
        if(this.input === null){
            return false;
        } else {
            return (this.input.length - this.counter) !== 0;
        }
    }

    public getOriginalData(): Array<T> | null {
        return this.input;
    }

    public resetPaginator(){
        this.counter = 0;
    }

    public getPageCounter(){
        return this.counter;
    }
}